import React, { useEffect, useState } from 'react';
import { isEmpty, sumBy, sum } from 'lodash';
import {  Grid, Box, Button, Typography, IconButton } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { AddCircleOutlineRounded, CloudDownloadRounded, DeleteRounded } from '@material-ui/icons';
import mime from 'mime';

import PopUp from '../../../../../commonModules/interface/PopUp';
import Axios from 'axios';
import FactureComptaPopUp from '../../purchases/FactureComptaPopUp';
import { Files } from '../../../../../commonModules/interface/input-files';
import DeleteDialog from '../../../../../commonModules/interface/DeleteDialog';
import LinkPurchasePopUp from '../purchases/LinkPurchasePopUp';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addFilesTransfer, deleteFileTransfer } from '../../../../../../../../jsx/actions/transferAction';

const FILENAMES = [
    "reappro_files",
    "transfer_files",
    "transfer_files_BL",
    "transfer_files_BESC",
    "transfer_files_fact",
]
// ADD     const addFilesPurchase = dispatch( addFilesPurchase());

const SingleTransferHeaderOptions = ({shop, transfer, onLinkCreditPayments}) => {
    // dispatch(fetchSaleCredits),
        // addFilesPurchase,
    //     addFacturesPurchase,
    //     fetchShops,
    //     getIncomeInfo,
    // const [transfer, setTransfer] = useState({});
    const dispatch = useDispatch();
    const SALE_CREDITS = useSelector((state) => state.inventory.credits); 
    const STATE_SALE = useSelector((state) => state.inventory.requestState.sales)
	const STATE_PURCHASE = useSelector((state) => state.inventory.requestState.purchases);
    const PURCHASES = useSelector((state) => state.inventory.purchases.PURCHASES);
    const SHOPS = useSelector((state) => state.inventory.shops); 
    const [addFiles, setAddFiles] = useState(false);
    const [newFiles, setNewFiles] = useState([]);
    const [localFiles, setLocalFiles] = useState(null);
    const [deleteFileTarget, setDeleteFileTarget] = useState(null);
    const [factExist, setFactExist] = useState({});
    const [factList, setFactList] = useState("");
    const [addFactures, setAddFactures] = useState(false);
    const [partDetails, setPartDetails] = useState({});
    const [parts, setParts] = useState({});
    const [totalPay, setTotalPay] = useState(0);
    const [spendingID, setSpendingID] = useState("");
    const [showFacturePopUp, setShowFacturePopUp] = useState(false);
    const [unlink, setUnlink] = useState({});
    const [fact_id_5000, setFactId5000] = useState("");
    const [checkedPayments, setCheckedPayments] = useState([]);
    // const [checkedPayments, setCheckedPayments] = useState([props.transfer.id]);
    const [errors, setErrors] = useState({
        fact_id_5000: "",
    });
    const [dlFiles, setDlFiles] = useState({});

    useEffect(() => {
        console.log("[INFO] MOUNTING SINGLE ");
        console.log('============SingleTransferHeaderOptions========================');
        console.log({shop, transfer});
        console.log('====================================');
    
        FILENAMES.map( fieldname => {
            if( !isEmpty(transfer[fieldname]) ) {
                transfer[fieldname].map( file => {
                    console.log('====================================');
                    console.log({file});
                    console.log('====================================');
                    downloadFile(file.filename)
                })
            }
        })
        
        // if ( transfer.sale_credit && isEmpty(SALE_CREDITS) ){
        //     props.fetchSaleCredits()
        // }

        if ( !isEmpty(transfer.fact_id_5000) ){
            let factList = transfer.fact_id_5000
            if (transfer.fact_id_5000.startsWith(", ")){
                factList = transfer.fact_id_5000.substring(2)
            }
            setFactList(factList)
            checkFactID(factList)
        }
      }, []);

    const downloadFile = async (path) => {
        try {
            const req = await fetch('/stocks/getPhotos', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({ path: path }),
                credentials: 'same-origin',
            });
            const src = await req.json();
            console.log(src);
            if (src.error) {
                console.log("[ERROR], fetching file ", src);
                toast.error("Fichier introuvable sur le serveur", { toastId: "dl-file-missing" })
                return;
            }

            setDlFiles((prevFiles) => ({
                ...prevFiles,
                [path]: src.uri,
            }));
        } catch (err) {
            console.log("[ERROR], catch fetching file", err);
            toast.error("Fichier introuvable sur le serveur", { toastId: "dl-file-missing" })
        }
    };

    const handleSubmit = async () => {
        const updated = await dispatch(addFilesTransfer({
            transfer_files: newFiles,
            id: transfer.id
        }))
        if (updated?.id) {
            setLocalFiles(updated.transfer_files)
            toast.info("L'opération a été modifiée avec succès")
            const existingFilenames = Object.keys(dlFiles)
            ;(updated.transfer_files || [])
                .filter(f => !existingFilenames.includes(f.filename))
                .forEach(f => downloadFile(f.filename))
            setNewFiles([])
            setAddFiles(false)
        } else {
            toast.error(STATE_PURCHASE.error || "Erreur lors de l'ajout des fichiers")
        }
    }
    const handleDeleteFile = async (password) => {
        const res = await dispatch(deleteFileTransfer({
            id: transfer.id,
            password,
            filename: deleteFileTarget.filename
        }))
        if (res?.id) {
            setLocalFiles(res.transfer_files ?? [])
            toast.info("L'opération a été modifiée avec succès")
            setDeleteFileTarget(null)
        } else {
            toast.error(res?.error || "Erreur")
        }
    }
    // const handleSubmitFact = async () => {
    //     let data = {
    //         fact_id_5000: fact_id_5000,
    //         id: props.transfer.id
    //     }
    //     if (props.transfer.transfer_type === "achat"){
    //         await props.addFacturesPurchase(data)
    //         if(STATE_PURCHASE.error){
    //             console.log("ERROR", STATE_PURCHASE.error);
                
    //             props.notif( "danger", STATE_PURCHASE.error)
    //         } else{
    //             console.log("fetched");
    //             //success 
                
    //             props.notif( "info", "L'achat a été modifié avec succès")
    //             setState({
    //                 addFactures: false,
    //                 fact_id_5000: transfer.fact_id_5000
    //             })
    //         }
    //     } 
    // }

	const rmPayment = (payID) => {
		let cpParts = Object.assign({}, parts)
		let newList = [].concat(checkedPayments)
		newList = newList.filter(id => id !== payID)
        delete cpParts[payID]

        console.log('====================================');
        console.log({cpParts});
        console.log('====================================');
        setCheckedPayments(newList)
        setParts(cpParts)
        setTotalPay(calcTotalV2(newList))
		// setState({
            //     checkedPayments : newList,
            //     parts: cpParts,
            // 	totalPay: calcTotalV2(newList)
            // });
    }
    
    const handleChangeParts = (parts) => {
        
        setParts(parts)
        setTotalPay( sum(Object.values(parts)));
        // setState({
        //     parts,
		// 	totalPay: sum(Object.values(parts))            
        // });
    }
    const handleSubmitLink = async () => {
		let data = {
			spending_id : spendingID,
			id_list: parts, 
			total: calcTotalV2(checkedPayments)
		}
		// await props.linkPurchasesTo5000(data)
		if(STATE_PURCHASE.error){ // STATE.purchases
			console.log("ERROR", STATE_PURCHASE.error)				
			toast.error( STATE_PURCHASE.error)
		} else {
			toast.info("Opération enregistrée avec succès")
			// handleSelectAllClick()                        	
		}
	}
	const handleSubmitUnLink = async () => {
		let data = {
			spending_id : unlink.fact_id_5000,
			id_list: [unlink.id], 
			total: unlink.total_price
		}
		// await props.unLinkPurchasesTo5000(data)
		if(STATE_PURCHASE.error){
			console.log("ERROR", STATE_PURCHASE.error)				
			toast.error(  STATE_PURCHASE.error)
		} else {
			toast.info("Opération enregistrée avec succès")
            setAddFactures(false)
			// handleSelectAllClick()                        	
		}
	}
	
	const calcTotalV2 = (list) => {		
		return sumBy(list, (purchaseID) => (parts[purchaseID]))
	} 
    const checkFactID = (fact_id_5000) => {
        let factExist = {}
        let factList = fact_id_5000
        let partDetails = {}
        let config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        
        if( transfer.transfer_type === "achat"){
            factList.split(", ").forEach( async (itemID, i) => {
                if (i === 0) {
                    const res1 = await Axios.post("/stocks/addData", {page:"purchases/match/part/list", data: transfer.id}, config)
                    console.log({res1});
        
                    if (res1.data ){
                        res1.data.forEach(item => partDetails[item.spending_id] = item)
                    }
                }
                if (itemID ) {
                    if (!factExist[itemID]) {
                        
                        const res = await Axios.post("/stocks/compta/spendings/single", {spendingID: itemID}, config)
                        console.log({res});
                        if (res.data && res.data.spending_id != "") {
                            res.transfer_type = "spending"
                            factExist[itemID] = res.data
                        }
                    }
                }
            })
        } else {
            factList.split(", ").forEach( async itemID => {
                if (itemID ) {
                    if (!factExist[itemID]) {
                        // const res = await props.getIncomeInfo(itemID)
                        // console.log('====================================');
                        // console.log({res});
                        // console.log('====================================');
                        // if (!res.error && res.income_amount !== 0) {
                        //     res.transfer_type = "income"
                        //     factExist[itemID] = res
                        // }
                    }
                }
            })
        }
        
        setFactExist(factExist)
        setFactList(factList)
        setPartDetails(partDetails)        
    }  
        
    // let list = []
    // let total_payed = 0
    // let rest = 0

    // console.log('====================================');
    // console.log(factList, );
    // console.log( factList.split(", "));
    // console.log( Object.keys(factExist));
    // console.log('====================================');

    // if(transfer.sale_credit) {
    //     list = filterList()
    //     list.forEach(item => total_payed += item.amount)
    //     console.log({list});
    //     rest = transfer.total_price - total_payed
    // }      
    
    return(
        <>
            {addFiles &&
                <PopUp
                    close={()=> setAddFiles(false)}
                    submitAction={handleSubmit}
                    maxWidth="sm"
                    title="Ajouter des fichiers"
                    disabledSubmit={STATE_PURCHASE.fetching}
                >
                    <Box p={1}>
                        <label htmlFor="transfer_files" className="control-label">Documents</label>
                        <Files
                            photoList={(files) => setNewFiles(files)}
                            photos={[]}
                            max={20}
                        />
                    </Box>
                </PopUp>
            }
            {deleteFileTarget &&
                <DeleteDialog
                    title="le fichier"
                    block={true}
                    close={() => setDeleteFileTarget(null)}
                    handleSubmit={handleDeleteFile}
                />
            }
            {addFactures &&
                <LinkPurchasePopUp
                    handleClose={()=> {
                        setAddFactures(false); 
                        setSpendingID("");
                        setShowFacturePopUp(false);
                        setCheckedPayments([]);
                        setParts({});
                        setTotalPay(0);
                    }}
                    rmPayment={rmPayment}
                    handleSubmitLink={handleSubmitLink}
                    handleChange={(e) => setSpendingID(e.target.value)}
                    handleChangeParts={handleChangeParts}
                    transfer={transfer}
                    checkedPayments={checkedPayments}
                    setSpendingID={setSpendingID}
                    spendingID={spendingID}
                    PURCHASES={PURCHASES}
                    SHOPS={SHOPS}
                    totalPay={totalPay}
                />
            }
            {showFacturePopUp && spendingID && spendingID.trim() !== "" && 
                <FactureComptaPopUp 
                    spendingID={spendingID} 
                    spending={factExist[spendingID]}
                    details={partDetails[spendingID]}
                    handleClose={() => {
                        setSpendingID("");
                        setShowFacturePopUp(false);
                    }}
                />
            }
            {transfer.nature !== "arrivage" ?
                <Box p={1}>
                    <Alert p={1}>
                        <AlertTitle>Pièces jointes</AlertTitle>
                        {!isEmpty(localFiles ?? transfer.transfer_files) && (localFiles ?? transfer.transfer_files).map( (file, i) => (
                            <Box display="inline-flex" alignItems="center" key={file.filename}>
                                <Button
                                    endIcon={<CloudDownloadRounded />}
                                    title="Télécharger"
                                    href={dlFiles[file.filename]}
                                    download={`${new Date(transfer.creation_date).toLocaleDateString('fr-FR')}_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`}
                                    onClick={(e) => {
                                        if (!dlFiles[file.filename]) {
                                            e.preventDefault();
                                            downloadFile(file.filename);
                                            toast.error("Fichier indisponible — nouvelle tentative de chargement…", { toastId: "dl-file-retry" })
                                        }
                                    }}
                                >
                                    Fichier {i+ 1}
                                </Button>
                                <IconButton
                                    title="Supprimer"
                                    onClick={() => setDeleteFileTarget(file)}
                                >
                                    <DeleteRounded color="error" />
                                </IconButton>
                            </Box>
                        )) }
                        {!isEmpty(transfer.reappro_files) && transfer.reappro_files.map( (file, i) => (
                            <Button
                                endIcon={<CloudDownloadRounded />}
                                title="Télécharger"
                                href={dlFiles[file.filename]}
                                download={`${new Date(transfer.creation_date).toLocaleDateString('fr-FR')}_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`}
                            >
                                Fichier {i+ 1}
                            </Button>
                        )) }
                        {isEmpty(localFiles ?? transfer.transfer_files) && isEmpty(transfer.reappro_files) && (
                            <Typography variant="body2" color="textSecondary">
                                Aucun fichier joint disponible
                            </Typography>
                        )}
                        {transfer.transfer_type === "achat" &&
                            <Box>
                                <Button
                                    startIcon={<AddCircleOutlineRounded /> }
                                    onClick={() => setAddFiles(true)}
                                    color="primary"
                                    variant="contained"
                                >
                                    Ajouter
                                </Button>
                            </Box>
                        }
                    </Alert>
                </Box>
                :
                <Box p={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6} md={3}>
                            <Alert>
                                <AlertTitle>Bon Livraison</AlertTitle>
                                {!isEmpty(transfer.transfer_files_BL) && transfer.transfer_files_BL.map( (file, i) => (
                                    <Button
                                        startIcon={<CloudDownloadRounded />}
                                        title="Télécharger"
                                        href={dlFiles[file.filename]} 
                                        download={`BL_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                    >
                                        Fichier {i+ 1}
                                    </Button>
                                )) }
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Alert>
                                <AlertTitle>BESC</AlertTitle>
                                {!isEmpty(transfer.transfer_files_BESC) && transfer.transfer_files_BESC.map( (file, i) => (
                                    <Button
                                        startIcon={<CloudDownloadRounded />}
                                        title="Télécharger"
                                        href={dlFiles[file.filename]} 
                                        download={`BESC_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                    >
                                        Fichier {i+ 1}
                                    </Button>
                                )) }
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Alert>
                                <AlertTitle>Facture</AlertTitle>
                                {!isEmpty(transfer.transfer_files_fact) && transfer.transfer_files_fact.map( (file, i) => (
                                    <Button
                                        startIcon={<CloudDownloadRounded />}
                                        title="Télécharger"
                                        href={dlFiles[file.filename]} 
                                        download={`Facture_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                    >
                                        Fichier {i+ 1}
                                    </Button>
                                )) }
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <Alert>
                                <AlertTitle>Autres Documents</AlertTitle>
                                {!isEmpty(transfer.transfer_files) && transfer.transfer_files.map( (file, i) => (
                                    <Button
                                        startIcon={<CloudDownloadRounded />}
                                        title="Télécharger"
                                        href={dlFiles[file.filename]} 
                                        download={`Autres_${i + 1}_${transfer.id.slice(0,8)}.${mime.getExtension(file.filetype)}`} 
                                    >
                                        Fichier {i+ 1}
                                    </Button>
                                )) }
                            </Alert>
                        </Grid>
                    </Grid>
                </Box>
            }
            {(transfer.nature !== "reapprovisionnement" && transfer.nature !== "draft" && transfer.nature !== "arrivage" && transfer.nature !== "demande" && transfer.nature !== "reservation") &&
                <Box p={1}>
                    <Alert severity="info" p={1}>
                        <AlertTitle>Factures 5000</AlertTitle>
                        { factList && factList.split(", ").map( (spend, i) => (
                            <Button
                                color="secondary"    
                                title="Voir"
                                href="#" 
                                onClick={()=> {
                                    setSpendingID(spend);
                                    setShowFacturePopUp(true);
                                }}
                            >
                                Facture {i+ 1}
                            </Button>
                        ))}
                        {transfer.transfer_type === "achat" &&
                            <Box>
                                <Button
                                    startIcon={<AddCircleOutlineRounded /> }
                                    onClick={() => {
                                        // Initialiser checkedPayments avec le transfer actuel
                                        setCheckedPayments([transfer.id]);
                                        setAddFactures(true);
                                    }}
                                    color="primary"
                                    variant="contained"
                                >
                                    Ajouter
                                </Button>
                            </Box>
                        }
                        {transfer.sale_credit && typeof onLinkCreditPayments === "function" &&
                            <Box>
                                <Button
                                    startIcon={<AddCircleOutlineRounded /> }
                                    onClick={() => onLinkCreditPayments(transfer)}
                                    color="primary"
                                    variant="contained"
                                >
                                    Pointer les paiements
                                </Button>
                            </Box>
                        }
                    </Alert>
                </Box>
            }
            

        </>
    );
}


export default SingleTransferHeaderOptions;
